"use client";

/**
 * By default, just select all of the text contents of the input,
 * but potentially allow the consumer to override this behavior.
 */
export function selectAllInputText(
  ref: React.MutableRefObject<HTMLInputElement>
) {
  ref.current.select();
}

/**
 * Select the name of the text input (i.e., without a file extension).
 */

export function selectName(ref: React.MutableRefObject<HTMLInputElement>) {
  const value = ref.current.value;
  ref.current.setSelectionRange(
    0,
    value.includes('.') ? value.lastIndexOf('.') : value.length
  );
}

export const selectionStrategies = {
  all: selectAllInputText,
  name: selectName,
};
